// processes
import ActionSet from './thens/processes/actionSet/ActionSet.vue';
import AddProductModal from './thens/processes/addProductModal/AddProductModal.vue';
import AddToSequence from './thens/processes/addToSequence/AddToSequence.vue';
import ApplyNote from './thens/processes/applyNote/ApplyNote.vue';
import ApplyRemoveTag from './thens/processes/applyRemoveTag/ApplyRemoveTag.vue';
import AssignOwner from './thens/processes/assignOwner/AssignOwner.vue';
import CancelSubscription from './thens/processes/cancelSubscription/CancelSubscription.vue';
import CreateAppointment from './thens/processes/createAppointment/CreateAppointment.vue';
import CreateDeal from './thens/processes/createDeal/CreateDeal.vue';
import CreateOpportunity from './thens/processes/createOpportunity/CreateOpportunity.vue';
import CreateOrder from './thens/processes/createOrder/CreateOrder.vue';
import CreateTask from './thens/processes/createTask/CreateTask.vue';
import FulfillmentModal from './thens/processes/fulfillment/FulfillmentModal.vue';
import FulfillmentAttachmentFile from './thens/processes/fulfillmentAttachmentFile/FulfillmentAttachmentFile.vue';
import FulfillmentBatch from './thens/processes/fulfillmentBatch/FulfillmentBatch.vue';
import FulfillmentContactList from './thens/processes/fulfillmentContactList/FulfillmentContactList.vue';
import FulfillmentDelivery from './thens/processes/fulfillmentDelivery/FulfillmentDelivery.vue';
import FulfillmentExportField from './thens/processes/fulfillmentExportField/FulfillmentExportField.vue';
import FulfillmentHeaderMenu from './thens/processes/fulfillmentHeaderMenu/FulfillmentHeaderMenu.vue';
import HttpCopyFromCampaign from './thens/processes/httpCopyFromCampaign/HttpCopyFromCampaign.vue';
import HttpRequestCopyFromCampaign from './thens/processes/httpRequestCopyFromCampaign/HttpRequestCopyFromCampaign.vue';
import MoveOpportunity from './thens/processes/moveOpportunity/MoveOpportunity.vue';
import ProcessModal from './thens/processes/processModal/ProcessModal.vue';
import SendHttpPost from './thens/processes/sendHttpPost/SendHttpPost.vue';
import SendHttpRequest from './thens/processes/sendHttpRequest/SendHttpRequest.vue';
import SetFieldValue from './thens/processes/setFieldValue/SetFieldValue.vue';
import UnsupportedBardEmail from './thens/communications/unsupportedBardEmail/UnsupportedBardEmail.vue';

export const ProcessModals = {
    ActionSet,
    AddProductModal,
    AddToSequence,
    ApplyNote,
    ApplyRemoveTag,
    AssignOwner,
    CancelSubscription,
    CreateAppointment,
    CreateDeal,
    CreateOpportunity,
    CreateOrder,
    CreateTask,
    FulfillmentModal,
    FulfillmentAttachmentFile,
    FulfillmentBatch,
    FulfillmentContactList,
    FulfillmentDelivery,
    FulfillmentExportField,
    FulfillmentHeaderMenu,
    HttpCopyFromCampaign,
    HttpRequestCopyFromCampaign,
    MoveOpportunity,
    ProcessModal,
    SendHttpPost,
    SendHttpRequest,
    SetFieldValue,
};

// other config modals
import DecisionDiamond from '../decisionDiamonds/DecisionDiamond.vue';
import IntegrationTriggerModal from './whens/integrationTriggerModal/IntegrationTriggerModal.vue';
import IntegrationActionModal from './thens/processes/integrationActionModal/IntegrationActionModal.vue';
import ElementNotSupportedModal from './ElementNotSupportedModal.vue';

export const OtherModals = {
    DecisionDiamond,
    IntegrationTriggerModal,
    IntegrationActionModal,
    ElementNotSupportedModal,
};

// goals
import ApiModal from './whens/api/ApiModal.vue';
import AppointmentEvent from './whens/appointmentEvent/AppointmentEvent.vue';
import CampaignBuilderMergeableTextArea from './whens/campaignBuilderMergeableTextArea/CampaignBuilderMergeableTextArea.vue';
import ConvrrtPageBuilder from './whens/convrrtPageBuilder/ConvrrtPageBuilder.vue';
import EmailLinkClicked from './whens/emailLinkClicked/EmailLinkClicked.vue';
import FailedPurchase from './whens/failedPurchase/FailedPurchase.vue';
import FormSubmitted from './whens/formSubmitted/FormSubmitted.vue';
import GoalModal from './whens/goalModal/GoalModal.vue';
import InternalFormSubmitted from './whens/internalFormSubmitted/InternalFormSubmitted.vue';
import LandingPage from './whens/landingPage/LandingPage.vue';
import LeadScore from './whens/leadScore/LeadScore.vue';
import LandingPageSubmitted from './whens/landingPageSubmitted/LandingPageSubmitted.vue';
import MergeFieldMenuOption from './whens/mergeFieldMenuOption/MergeFieldMenuOption.vue';
import NoteApplied from './whens/noteApplied/NoteApplied.vue';
import OpportunityStageMoved from './whens/opportunityStageMoved/OpportunityStageMoved.vue';
import PipelineStageMove from './whens/pipelineStageMove/PipelineStageMove.vue';
import ProductPurchased from './whens/productPurchased/ProductPurchased.vue';
import QuoteStatus from './whens/quoteStatus/QuoteStatus.vue';
import TagApplied from './whens/tagApplied/TagApplied.vue';
import TaskComplete from './whens/taskComplete/TaskComplete.vue';
import TaskCompleteRule from './whens/taskCompleteRule/TaskCompleteRule.vue';
import WebFormSubmitted from './whens/webFormSubmitted/WebFormSubmitted.vue';
import WebPageAutomation from './whens/webPageAutomation/WebPageAutomation.vue';
import WordPressOptIn from './whens/wordPressOptIn/WordPressOptIn.vue';

export const GoalModals = {
    ApiModal,
    AppointmentEvent,
    CampaignBuilderMergeableTextArea,
    ConvrrtPageBuilder,
    EmailLinkClicked,
    FailedPurchase,
    FormSubmitted,
    GoalModal,
    InternalFormSubmitted,
    LandingPage,
    LeadScore,
    LandingPageSubmitted,
    MergeFieldMenuOption,
    NoteApplied,
    OpportunityStageMoved,
    PipelineStageMove,
    ProductPurchased,
    QuoteStatus,
    TagApplied,
    TaskComplete,
    TaskCompleteRule,
    WebFormSubmitted,
    WebPageAutomation,
    WordPressOptIn,
};

// timers
import AppointmentTimer from './thens/timers/appointmentTimer/AppointmentTimer.vue';
import DateTimer from './thens/timers/dateTimer/DateTimer.vue';
import DelayTimer from './thens/timers/delayTimer/DelayTimer.vue';
import FieldTimer from './thens/timers/fieldTimer/FieldTimer.vue';
import TimerModal from './thens/timers/timerModal/TimerModal.vue';

export const TimerModals = {
    AppointmentTimer,
    DateTimer,
    DelayTimer,
    FieldTimer,
    TimerModal,
};

// communications
import EmailConfirmation from './thens/communications/emailConfirmation/EmailConfirmation.vue';
import LegacyEmail from './thens/communications/legacyEmail/LegacyEmail.vue';
import LetterModal from './thens/communications/letter/LetterModal.vue';
import SmsBuilder from './thens/communications/smsBuilder/SmsBuilder.vue';
import UnlayerEmail from './thens/communications/unlayerEmail/UnlayerEmail.vue';
import UnlayerConfirmationEmail from './thens/communications/emailConfirmation/UnlayerEmailConfirmation.vue';

export const CommunicationsModals = {
    EmailConfirmation,
    LegacyEmail,
    LetterModal,
    SmsBuilder,
    UnlayerEmail,
    UnsupportedBardEmail,
    UnlayerConfirmationEmail,
};
